// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"ReadingViewSkeleton_skeletonContainer__h5Sb2","skeleton":"ReadingViewSkeleton_skeleton__hw8ZE","fixedWidth":"ReadingViewSkeleton_fixedWidth__fIRzb"};